import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export const Route = createFileRoute("/cuenta/reset-password")({
  head: () => ({ meta: [{ title: "Nueva contraseña — Truck Company Center" }, { name: "robots", content: "noindex" }] }),
  component: ResetPassword,
});

function ResetPassword() {
  const nav = useNavigate();
  const [ready, setReady] = useState(false);
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Supabase processes the recovery hash automatically; wait for session.
    const sub = supabase.auth.onAuthStateChange((event) => {
      if (event === "PASSWORD_RECOVERY" || event === "SIGNED_IN") setReady(true);
    });
    supabase.auth.getSession().then(({ data }) => { if (data.session) setReady(true); });
    return () => { sub.data.subscription.unsubscribe(); };
  }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    setLoading(false);
    if (error) { toast.error(error.message); return; }
    toast.success("Contraseña actualizada");
    nav({ to: "/cuenta" });
  }

  return (
    <div className="mx-auto max-w-md px-4 py-16 md:px-6">
      <h1 className="font-display text-3xl font-semibold text-foreground">Nueva contraseña</h1>
      {!ready ? (
        <p className="mt-4 text-sm text-muted-foreground">Validando enlace de recuperación...</p>
      ) : (
        <form onSubmit={submit} className="mt-6 space-y-3 rounded-xl border border-hairline bg-surface p-6">
          <div>
            <Label className="text-xs text-muted-foreground">Nueva contraseña (mínimo 6 caracteres)</Label>
            <Input className="bg-surface-2 border-hairline" type="password" minLength={6} required value={password} onChange={(e) => setPassword(e.target.value)} />
          </div>
          <Button type="submit" disabled={loading} className="w-full bg-primary text-primary-foreground hover:bg-primary/90">
            {loading ? "..." : "Guardar"}
          </Button>
        </form>
      )}
    </div>
  );
}
